exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity0[data-v-7f62499c]{opacity:0}.wrapper-name[data-v-7f62499c]{display:flex;white-space:nowrap}.wrapper-name .name[data-v-7f62499c]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
